/**
 * 视频上传截取首帧demo
 * @description 视频上传截取首帧demo
 * @author yly
 * @date 2023-03-29
 */
import React from 'react';
import { connect } from 'dva';
import { framework_tool } from '../../../tool'
let { WizContainer } = framework_tool;
import UploadVideoToPic from '../../common/uploadVideoToPic'
import BigAvatarUpload from '../../common/bigAvatarUpload'

class videoGetPicDemo extends WizContainer {
  componentName = 'UploadDemo';
  // 构造函数
  constructor(props) {
    super(props);
    this.state = {
      fileList: [], //文件列表
      imgValue: [{ fileId: '20230329154944505e7a89ab774fe1aa' }], //图片
      coverUse: 1,//是否作为封面图使用
      fileTypeStr: ".pdf,.doc,.docx,.mp4",//支持格式
    };
  }

  // 获取组件返回值
  handleUploadVideoOnChange = values => {
    console.log(values, 'values')
  };

  _render() {
    let { fileList, imgValue, coverUse, fileTypeStr } = this.state

    return (
      <>      <UploadVideoToPic fileTypeStr={fileTypeStr} onChange={this.handleUploadVideoOnChange} value={fileList} imgValue={imgValue}
      // coverUse={coverUse}
      ></UploadVideoToPic>
        <BigAvatarUpload></BigAvatarUpload>
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
  };
};

export default connect(mapStateToProps)(videoGetPicDemo);
